export default __webpack_public_path__ + "static/media/commonocean-rules.ba684c79.md";